import {
    // SWITCH_PRODUCT_TYPE,
    PROJECTS_CRUD_MODAL,
    PROJECTS_CRUD_SET_LIST,
    PROJECTS_CRUD_RESET,
    PROJECTS_CRUD_RESTORE_STATE,
    LEGACY_COMPONENT_USER_DIALOG,
    GLOBAL_PROJECT_TYPE_CHAMBER,
    SHOW_MANIFOLD_ENTRY,
    CLOSE_MANIFOLD_ENTRY, FLOATING_TOOL_TEE_CLOSE,
} from "../lib/types";
import {
    setChamberType,
} from "../actions/apptoolbar-actions";

export const toggleProjectsCrudModal = toggle => dispatch => {
    dispatch({
        type: PROJECTS_CRUD_MODAL,
        payload: toggle,
    });
};

export const setProjectsList = projects => dispatch => {
    dispatch({
        type: PROJECTS_CRUD_SET_LIST,
        payload: projects,
    });
};

export const resetProjectsList = () => dispatch => {
    dispatch({
        type: PROJECTS_CRUD_RESET,
    });
};

/**
 * Prepares the state that will persis data on server
 * @returns {*}}
 */
export const getStateToPersist = () => (dispatch, getState) => {
    /* extracting all necessary state */
    let {
        globals,
        viewport,
        background,
        chamberbed,
        stonebed,
        calculations,
        upperManifolds,
        lowerManifolds,
        mainManifolds,
        pdf,
        systemParameters,
        localization,

        pipeGlobals,
        pipeBed,

        multiBed,
        subProject,
    } = getState();

    // delete localization.regions;
    // delete localization.languages;
    // delete localization.units;
    // delete localization.content;
    // delete localization.lbl;

    /* NOTE: Sensitive background extraction here */
    if (background.bgImg) {
        let image = background.bgImg;
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        canvas.getContext("2d").drawImage(image, 0, 0);
        /* extract the base64 enconded bytes(strip the 'data:image/png;base64,') */
        background.specs = {
            data: canvas.toDataURL("image/png"),
            height: image.height,
            width: image.width,
        };
    }
    /* return the extracted state */
    return {
        globals,
        viewport,
        background,
        chamberbed,
        stonebed,
        calculations,
        upperManifolds,
        lowerManifolds,
        mainManifolds,
        pdf, // metadata about background image and loaded pdf
        systemParameters, // parameters used to persist values on System Parameters on left menu, and Advanced settings
        localization: {
            ...localization,
            regions: null,
            languages: null,
            units: null,
            content: null,
            lbl: null
        },

        // pipe additions
        pipeGlobals,
        pipeBed,

        // multibed additions
        multiBed,
        subProject
    };
};

/**
 * NOTE: This function invokes set state twice to prevent
 * inconsistencies of state when componentDidUpdate are
 * executed in other components. Two pases will make sure
 * the state is correct.
 *
 * @param {Object} state Unserialized minicad state.
 */
export const restorePersistedState = (state) => (dispatch, getState) => {
    const previousState = getState();

    // Fix chamber type before sending it along
    const { chambers, endcaps } = previousState.apptoolbar;
    let { chamberType, chamberEndCapType } = state.globals;

    const chamberbed = state.chamberbed;
    const { totalStorageProvided } = state.calculations;

    chamberType = chamberType || previousState.globals.chamberType;
    chamberEndCapType = chamberEndCapType || previousState.globals.chamberEndCapType;

    let newChamberType = chambers.find(chamber => chamber.id === chamberType.id);
    let newChamberEndCapType = endcaps.find(endCap => endCap.id === chamberEndCapType.id);

    if (state.globals.projectType === GLOBAL_PROJECT_TYPE_CHAMBER
        && newChamberType.id === "MC-4500"
        && chamberEndCapType.installedLength < newChamberEndCapType.installedLength) {
        // This project was using the old MC-4500 endcap specs
        if (!previousState.apptoolbar.showLegacyComponentDialog) {
            dispatch({
                type: LEGACY_COMPONENT_USER_DIALOG,
                payload: {
                    showDialog: true,
                },
            });
        }
        setChamberType(newChamberType, newChamberEndCapType);
    }
    if (previousState.manifoldEntry && previousState.manifoldEntry.showManifoldEntryDialog) {
        dispatch({
            type: SHOW_MANIFOLD_ENTRY,
            payload: {
                accessory: {},
                manifoldId: null,
                showManifoldEntryDialog: false,
            },
        });
        dispatch({
            type: CLOSE_MANIFOLD_ENTRY,
        });
        dispatch({
            type: FLOATING_TOOL_TEE_CLOSE,
        });
    }
    const isDeskTop = ( !!window._bridge );

    dispatch({
        type: PROJECTS_CRUD_RESTORE_STATE,
        payload: {
            ...state,
            globals: {
                ...state.globals,
                chamberType: newChamberType,
                chamberEndCapType: newChamberEndCapType,
            },
            chamberbed,
            totalStorageProvided,
            isDeskTop,
        },
    });
};

/**
 * Second reload of state quick fix
 * @param state
 * @returns {function(*, *): void}
 */
export const doubleTapRestorePersistedState = (state) => (dispatch, getState) => {
    const previousState = getState();

    const { chambers, endcaps } = previousState.apptoolbar;
    let { chamberType, chamberEndCapType } = state.globals;
    chamberType = chamberType || previousState.globals.chamberType;
    chamberEndCapType = chamberEndCapType || previousState.globals.chamberEndCapType;
    let newChamberType = chambers.find(chamber => chamber.id === chamberType.id);
    let newChamberEndCapType = endcaps.find(endCap => endCap.id === chamberEndCapType.id);
    const { totalStorageProvided } = state.calculations;

    const chamberbed = state.chamberbed;
    const isDeskTop = ( !!window._bridge );
    dispatch({
        type: PROJECTS_CRUD_RESTORE_STATE,
        payload: {
            ...state,
            globals: {
                ...state.globals,
                chamberType: newChamberType,
                chamberEndCapType: newChamberEndCapType,
            },
            chamberbed,
            totalStorageProvided,
            isDeskTop,
        },
    });
};



// WEBPACK FOOTER //
// ./src/actions/project-crud-actions.js